export const agendaItemsSelector = (state) => state.ui.presentation.agendaItems;